import { render } from "./FeaturesComponent.vue?vue&type=template&id=49cdc3a5&scoped=true"
import script from "./FeaturesComponent.vue?vue&type=script&lang=js"
export * from "./FeaturesComponent.vue?vue&type=script&lang=js"

import "./FeaturesComponent.vue?vue&type=style&index=0&id=49cdc3a5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cdc3a5"]])

export default __exports__